import { FunctionComponent } from 'react';
import { LoadingBar } from '../../Features/LoadingBar/LoadingBarConnector';
import { IHoldingPageStoreProps } from './HoldingPageConnector';

type HoldingPageType = FunctionComponent<IHoldingPageStoreProps>;
export const HoldingPage: HoldingPageType = () => <LoadingBar />;
